import { render, staticRenderFns } from "./TicimaxChannelsV2.vue?vue&type=template&id=0a50b3ef&scoped=true"
import script from "./TicimaxChannelsV2.vue?vue&type=script&lang=js"
export * from "./TicimaxChannelsV2.vue?vue&type=script&lang=js"
import style0 from "./TicimaxChannelsV2.vue?vue&type=style&index=0&id=0a50b3ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50b3ef",
  null
  
)

export default component.exports